import React, { useMemo, useRef, useState, useEffect, useContext } from "react";

import { FormControl } from "@chakra-ui/react";
import {
  Search,
  MoreVertical,
  Paperclip,
  Smile,
  Send,
  CheckCheck,
  Circle,
  ArrowLeft,
  X,
} from "lucide-react";
import { Input } from "@chakra-ui/react";
import { Box, Text } from "@chakra-ui/react";
import "./styles.css";
import { IconButton, Spinner, useToast } from "@chakra-ui/react";
import { getSender, getSenderFull } from "../../config/ChatLogics";
import axios from "../../AxiosInstance";
import { IoMdArrowBack } from "react-icons/io";
import ScrollableChat from "./ScrollableChat";
import Lottie from "react-lottie";
import animationData from "../../animations/typing.json";
import { IoIosAttach } from "react-icons/io";
import { ChatState } from "../../context/ChatProvider";
import SocketContext from "../../context/SocketContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../context/auth";
import { Dropdown, Modal } from "react-bootstrap";
import { BASE_URL } from "../../config/BaseUrls";
import EmojiPicker from "emoji-picker-react";
import { toast } from "react-hot-toast";
import { LanguageContext } from "../../context/LanguageContext";
import UpdateGroupChatModal from "./UpdateGroupChat";
import { resolveBookImageUrl } from "../../utils/urlHelpers";
// const BASE_URL = process.env.PORT;
const PRIMARY = "#34c3c9";
const ENDPOINT = "https://rentyoyo-production.up.railway.app"; // "https://talk-a-tive.herokuapp.com"; -> After deployment
var selectedChatCompare;
function ActionCard({
  requester,
  bookTitle,
  duoType,
  cover,
  when,
  user,
  users,
  onClick,
  handleReject,
}) {
  const navigate = useNavigate();
  return (
    <div className="flex justify-start">
      {/* card bubble */}
      <div className="w-full max-w-[560px] rounded-2xl border border-[#e9e9e9] bg-white p-4 shadow-sm ring-1 ring-black/0">
        {/* title row */}
        <div className="mb-3 flex items-center gap-3">
          <div className="h-10 w-10 flex-shrink-0 overflow-hidden rounded-md ring-1 ring-[#e7e7e7]">
            <img
              src={cover}
              alt="Book cover"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="min-w-0">
            <p className="text-sm text-slate-700">
              <span className="font-semibold">{requester?.name}</span> would
              like to start a
              <span className="ml-1 inline-flex items-center rounded-full bg-[#34c3c9]/10 px-2 py-0.5 text-xs font-semibold text-[#0f7d82] ring-1 ring-[#34c3c9]/20">
                {duoType}
              </span>
              <span className="ml-1">with you</span>
            </p>
            <p className="truncate text-sm font-medium text-[#0f172a]">
              {bookTitle}
            </p>
            {/* <p className="text-xs text-slate-500">📅 {when}</p> */}
          </div>
        </div>

        {/* prompt */}
        <p className="mb-4 text-sm text-slate-800">
          Do you want to start the conversation?
        </p>

        {/* actions */}
        <div className="flex flex-wrap gap-2">
          <button
            className="rounded-xl bg-[#34c3c9] px-4 py-2 text-sm font-medium text-white shadow-sm hover:brightness-95 focus:outline-none focus:ring-2 focus:ring-[#34c3c9]/50"
            onClick={onClick}
          >
            Accept
          </button>
          <button
            className="rounded-xl bg-[#f2f2f2] px-4 py-2 text-sm font-medium text-slate-800 shadow-sm hover:bg-[#eaeaea] focus:outline-none focus:ring-2 focus:ring-slate-200"
            onClick={handleReject}
          >
            Reject
          </button>
          <button
            className="ml-auto rounded-xl px-3 py-2 text-sm text-[#34c3c9] hover:bg-[#34c3c9]/10"
            onClick={(e) => {
              e.stopPropagation(); // Prevent parent click event
              let other = getSenderFull(user, users);
              navigate(`/ambassadoruserprofile?id=${other?._id}`);
            }}
          >
            View profile
          </button>
        </div>
      </div>
    </div>
  );
}

const SingleChat = ({ fetchAgain, setFetchAgain }) => {
  const { lg } = useContext(LanguageContext);

  const { id: urlChatId } = useParams();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const source = queryParams.get("source"); // e.g., ?source=email
  const socket = useContext(SocketContext);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [isExternal, setIsExternal] = useState(false);
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [newMessage, setNewMessage] = useState("");
  const [socketConnected, setSocketConnected] = useState(false);
  const [typing, setTyping] = useState(false);
  const [iMage, setIMage] = useState(null);
  const [i, setI] = useState(null);
  const [istyping, setIsTyping] = useState(false);
  const toast = useToast();
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [chatCleared, setChatCleared] = useState(false);

  const onEmojiClick = (emojiData, event) => {
    setNewMessage((prev) => prev + emojiData.emoji);
  };
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const {
    selectedChat,
    setSelectedChat,
    user,
    notification,
    setChats,
    setNotification,
  } = ChatState();

  const fetchMessages = async (chatId) => {
    if (!chatId) return;

    try {
      setLoading(true);
      const { data } = await axios.get(
        `api/v1/chat/messages/${chatId}?userId=${user._id}`
      );

      setMessages(data);
      socket.emit("join chat", chatId);
    } catch (error) {
      toast({
        title: "Error Occured!",
        description: "Failed to Load the Messages",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
    } finally {
      setLoading(false);
    }
  };
  const fetchChatDetails = async (chatId) => {
    try {
      const { data } = await axios.get(
        `api/v1/chat/chat/${chatId}?userId=${user._id}`
      );
      setSelectedChat(data);
      return data;
    } catch (error) {
    
      return null;
    }
  };
  const sendMessage = async (event) => {
    if (
      selectedChat?.status !== "accepted" &&
      currentBook?.title === "Book Duo"
    ) {
      toast({
        title: "Error Occured!",
        description: "You can't send message until the chat is accepted",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "top",
      });
      return;
    }

    console.log(event, "event");
    if ((event.key === "Enter" || event.type === "click") && newMessage) {
      socket.emit("stop typing", selectedChat._id);
      try {
        setNewMessage("");
        setI(null);
        if (iMage !== null) {
          let d = new FormData();

          d.append("chatId", selectedChat._id);
          d.append("image", iMage);
          console.log(iMage, "iMage to");

          d.append("sender", user._id);
          const { data } = await axios.post("api/v1/chat/image", d, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
          setIMage(null);
          socket.emit("new message", data);

          setMessages([...messages, data]);
        } else {
          const { data } = await axios.post("api/v1/chat/access", {
            content: newMessage,
            chatId: selectedChat,
            sender: user._id,
          });
          socket.emit("new message", data);
          setMessages([...messages, data]);
        }
      } catch (error) {
        toast({
          title: "Error Occured!",
          description: "Failed to send the Message",
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "bottom",
        });
      }
    }
  };
  const handleResponse = async (accepted) => {
    try {
      // Emit response to server
      socket.emit("respond_to_request", {
        userId: getSenderFull(user, selectedChat.users)._id,
        ambassadorId: user._id,
        chatId: selectedChat._id,
        accepted,
      });
      if (accepted) {
        // ✅ Just update status locally
        setSelectedChat((prev) => ({
          ...prev,
          status: "accepted",
        }));
      } else {
        // ❌ Rejected — remove from list, state, and URL
        setChats((prev) =>
          prev.filter((chat) => chat._id !== selectedChat._id)
        );
        setSelectedChat(null);

        // ✅ Clean up the URL if using React Router or Next.js router
        navigate("/chatChak");
      }
      toast({
        title: accepted ? "Request Accepted" : "Request Declined",
        description: accepted
          ? "You've accepted the chat request"
          : "You've declined the chat request",
        status: accepted ? "success" : "info",
        duration: 5000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: "Error",
        description: "Failed to process request",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };
  useEffect(() => {
    // socket = io(BASE_URL);
    // socket.emit("setup", user);
    console.log("socket", socket);
    if (user?._id && socket) {
      socket.on("connected", () => {
        console.log("set conne");
        setSocketConnected(true);
      });
      socket.on("typing", () => {
        console.log("typing");
        setIsTyping(true);
      });
      socket.on("stop typing", () => {
        console.log("stop typing");
        setIsTyping(false);
      });
    }
    // eslint-disable-next-line
  }, [user, socket]);
  useEffect(() => {
    let isMounted = true;
    const queryParams = new URLSearchParams(location.search);
    const source = queryParams.get("source");

    const loadChat = async () => {
      // Skip entirely if no chat ID available
      if (!urlChatId && !selectedChat?._id) return;

      const chatIdToUse = urlChatId || selectedChat?._id;

      if (urlChatId && (!selectedChat || selectedChat._id !== urlChatId)) {
        setIsExternal(source === "external");
        const fetched = await fetchChatDetails(urlChatId);
        if (fetched && isMounted) {
          await fetchMessages(fetched?._id);
          selectedChatCompare = fetched;
        }
      } else if (selectedChat?._id) {
        selectedChatCompare = selectedChat;
        await fetchMessages(selectedChat._id);
      }
    };

    loadChat();
    console.log(selectedChat?.event, "selectedChat?.event");
    setCurrentBook(selectedChat?.event || {});
    return () => {
      isMounted = false;
    };
  }, [urlChatId, selectedChat, location.search, chatCleared]);
  useEffect(() => {
    if (socket) {
      socket.on("message recieved", (newMessageRecieved) => {
        // alert("message received");

        if (
          !selectedChatCompare || // if chat is not selected or doesn't match current chat
          selectedChatCompare._id !== newMessageRecieved.chat._id
        ) {
          if (!notification.includes(newMessageRecieved)) {
            setNotification([newMessageRecieved, ...notification]);
            setFetchAgain(!fetchAgain);
          }
        } else {
          setMessages([...messages, newMessageRecieved]);
        }
      });
      // Handle chat acceptance
    }
  });
  useEffect(() => {
    const handleChatAccepted = ({ chatId, status, participants }) => {
      setSelectedChat((prev) => ({
        ...prev,
        status,
      }));

      toast({
        title: "Chat Accepted!",
        description: "You can now start messaging",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    };

    const handleChatRejected = ({ chatId }) => {
      localStorage.removeItem("selectedChat");

      toast({
        title: "Chat Rejected",
        description: "The ambassador declined your request",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      setChats((prev) => prev.filter((chat) => chat._id !== selectedChat._id));
      setSelectedChat(null);

      // ✅ Clean up the URL if using React Router or Next.js router
      navigate("/chatChak");
    };

    socket.on("chat_accepted", handleChatAccepted);
    socket.on("chat_rejected", handleChatRejected);

    return () => {
      socket.off("chat_accepted", handleChatAccepted);
      socket.off("chat_rejected", handleChatRejected);
    };
  }, [socket]);
  const typingHandler = (e) => {
    setNewMessage(e.target.value);
    console.log(setNewMessage, "setNewMessage");
    if (!socketConnected) return;

    if (!typing) {
      setTyping(true);
      socket.emit("typing", selectedChat._id);
    }
    let lastTypingTime = new Date().getTime();
    var timerLength = 3000;
    setTimeout(() => {
      var timeNow = new Date().getTime();
      var timeDiff = timeNow - lastTypingTime;
      if (timeDiff >= timerLength && typing) {
        socket.emit("stop typing", selectedChat._id);
        setTyping(false);
      }
    }, timerLength);
  };

  const [currentBook, setCurrentBook] = useState({});

  const [auth, setAuth] = useAuth(); // If using Context API
  const navigate = useNavigate();
  const userId = auth?.user?._id;

  const [users, setUsers] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      if (!userId) return; // Don't make API call if userId is undefined
      try {
        const res = await axios.get(`/api/v1/auth/user-profile/${userId}`);
        setUsers(res.data.data);
      } catch (err) {
        console.error("Error:", err);
      }
    };

    fetchUser();
  }, [userId]);

  const getChatPartner = (users) => {
    return users?.find((u) => u._id !== user._id);
  };

  const partner = getChatPartner(selectedChat?.users);
  console.log("Profile home main image path:", partner?.profileImage); // <--- Add this line

  const capitalizeWords = (str) => {
    return str
      ?.split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const countryNameToCode = {
    Afghanistan: "AF",
    Albania: "AL",
    Algeria: "DZ",
    Andorra: "AD",
    Angola: "AO",
    "Antigua and Barbuda": "AG",
    Argentina: "AR",
    Armenia: "AM",
    Australia: "AU",
    Austria: "AT",
    Azerbaijan: "AZ",
    Bahamas: "BS",
    Bahrain: "BH",
    Bangladesh: "BD",
    Barbados: "BB",
    Belarus: "BY",
    Belgium: "BE",
    Belize: "BZ",
    Benin: "BJ",
    Bhutan: "BT",
    Bolivia: "BO",
    "Bosnia and Herzegovina": "BA",
    Botswana: "BW",
    Brazil: "BR",
    Brunei: "BN",
    Bulgaria: "BG",
    "Burkina Faso": "BF",
    Burundi: "BI",
    Cambodia: "KH",
    Cameroon: "CM",
    Canada: "CA",
    "Cape Verde": "CV",
    "Central African Republic": "CF",
    Chad: "TD",
    Chile: "CL",
    China: "CN",
    Colombia: "CO",
    Comoros: "KM",
    "Congo (Brazzaville)": "CG",
    "Congo (Kinshasa)": "CD",
    "Costa Rica": "CR",
    Croatia: "HR",
    Cuba: "CU",
    Cyprus: "CY",
    "Czech Republic": "CZ",
    Denmark: "DK",
    Djibouti: "DJ",
    Dominica: "DM",
    "Dominican Republic": "DO",
    Ecuador: "EC",
    Egypt: "EG",
    "El Salvador": "SV",
    "Equatorial Guinea": "GQ",
    Eritrea: "ER",
    Estonia: "EE",
    Eswatini: "SZ",
    Ethiopia: "ET",
    Fiji: "FJ",
    Finland: "FI",
    France: "FR",
    Gabon: "GA",
    Gambia: "GM",
    Georgia: "GE",
    Germany: "DE",
    Ghana: "GH",
    Greece: "GR",
    Grenada: "GD",
    Guatemala: "GT",
    Guinea: "GN",
    "Guinea-Bissau": "GW",
    Guyana: "GY",
    Haiti: "HT",
    Honduras: "HN",
    Hungary: "HU",
    Iceland: "IS",
    India: "IN",
    Indonesia: "ID",
    Iran: "IR",
    Iraq: "IQ",
    Ireland: "IE",
    Israel: "IL",
    Italy: "IT",
    Jamaica: "JM",
    Japan: "JP",
    Jordan: "JO",
    Kazakhstan: "KZ",
    Kenya: "KE",
    Kiribati: "KI",
    "Korea, North": "KP",
    "Korea, South": "KR",
    Kuwait: "KW",
    Kyrgyzstan: "KG",
    Laos: "LA",
    Latvia: "LV",
    Lebanon: "LB",
    Lesotho: "LS",
    Liberia: "LR",
    Libya: "LY",
    Liechtenstein: "LI",
    Lithuania: "LT",
    Luxembourg: "LU",
    Madagascar: "MG",
    Malawi: "MW",
    Malaysia: "MY",
    Maldives: "MV",
    Mali: "ML",
    Malta: "MT",
    "Marshall Islands": "MH",
    Mauritania: "MR",
    Mauritius: "MU",
    Mexico: "MX",
    Micronesia: "FM",
    Moldova: "MD",
    Monaco: "MC",
    Mongolia: "MN",
    Montenegro: "ME",
    Morocco: "MA",
    Mozambique: "MZ",
    Myanmar: "MM",
    Namibia: "NA",
    Nauru: "NR",
    Nepal: "NP",
    Netherlands: "NL",
    "New Zealand": "NZ",
    Nicaragua: "NI",
    Niger: "NE",
    Nigeria: "NG",
    "North Macedonia": "MK",
    Norway: "NO",
    Oman: "OM",
    Pakistan: "PK",
    Palau: "PW",
    Panama: "PA",
    "Papua New Guinea": "PG",
    Paraguay: "PY",
    Peru: "PE",
    Philippines: "PH",
    Poland: "PL",
    Portugal: "PT",
    Qatar: "QA",
    Romania: "RO",
    Russia: "RU",
    Rwanda: "RW",
    "Saint Kitts and Nevis": "KN",
    "Saint Lucia": "LC",
    "Saint Vincent and the Grenadines": "VC",
    Samoa: "WS",
    "San Marino": "SM",
    "Sao Tome and Principe": "ST",
    "Saudi Arabia": "SA",
    Senegal: "SN",
    Serbia: "RS",
    Seychelles: "SC",
    "Sierra Leone": "SL",
    Singapore: "SG",
    Slovakia: "SK",
    Slovenia: "SI",
    "Solomon Islands": "SB",
    Somalia: "SO",
  };
  useEffect(() => {
    const savedUser = localStorage.getItem("selectedUser");
    if (savedUser) {
      setSelectedChat(JSON.parse(savedUser));
    }
  }, []);

  const handleBlockUnblockChat = async () => {
    try {
      const block = selectedChat?.status !== "blocked";

      const { data } = await axios.post("/api/v1/chat/block-unblock-chat", {
        chatId: selectedChat._id,
        block,
        userId: user._id,
      });

      setSelectedChat(data);

      toast({
        title: block ? "User Blocked" : "User Unblocked",
        description: block
          ? "You will no longer receive & send messages from this user."
          : "Chat is Unblock.",
        status: block ? "warning" : "success",
        duration: 4000,
        isClosable: true,
      });
    } catch (err) {
      toast({
        title: "Error",
        description: "Could not update block status",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
  };

  const handleCancel = async () => {
    // setSelectedChat(null);
    try {
      const res = await axios.post("/api/v1/chat/cancel-chat", {
        userId: user._id, // or whatever field has userId
        chatId: selectedChat?._id,
      });
      console.log(res.data, "cancel chat response");

      if (res.data.success) {
        toast({
          title: "Done!",
          description: "You have cleared all messages.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        handleClose(); // Close the modal after clearing
        await fetchMessages(selectedChat._id);
        setChatCleared((prev) => !prev); // toggle so it re-triggers useEffect
      } else {
        // toast.error("Failed to report.");
      }
    } catch (err) {
      console.log(err);
    }
  };
  console.log(selectedChat, "selectedChat");
  const [text, setText] = useState("");
  const endRef = useRef(null);
  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: "smooth" });
  }, []);
  console.log(user?._id, selectedChat, "selectedChat?.event?.userId");
  console.log("🔍 Debug Info:");
console.log("User:", user);
console.log("Selected Chat:", selectedChat);
console.log("Current Book:", currentBook);
console.log("Chat Status:", selectedChat?.status);
console.log("Organizer ID:", selectedChat?.event?.userId);
console.log("Is Organizer:", String(user?._id) === String(selectedChat?.event?.userId));
  return (
    <>
      {selectedChat ? (
        <>
          <div
            className="w-100 h-100 pt-3 d-none w-full"
            // style={{ backgroundColor: "#D9D9D952" }}
          >
            <Text
              fontSize={{ base: "28px", md: "30px" }}
              px="30px"
              w="100%"
              d="flex"
              justifyContent={{ base: "space-between" }}
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
              alignItems="center"
            >
              <IconButton
                display={{ base: "flex", md: "none" }}
                icon={<IoMdArrowBack />}
                onClick={() => {
                  setSelectedChat("");
                  navigate("/chatChak/");
                  localStorage.removeItem("selectedUser");
                }}
              />
              {messages &&
                (!selectedChat.isGroupChat ? (
                  <>
                    <div
                      style={{ width: "100%" }}
                      className="d-flex justify-content-between align-items-center "
                    >
                      <div
                        className="d-flex  align-items-center"
                        style={{ gap: "14px" }}
                      >
                        <img
                          src={
                            partner?.profileImage?     partner?.profileImage?.startsWith("http")? partner?.profileImage
                              : `${BASE_URL}/uploads/${partner.profileImage}`
                              : require("../../pages/image/addphotoicon.png")
                          }
                          alt={`${partner?.name || "User"} photo`}
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent parent click event
                            let other = getSenderFull(
                              user,
                              selectedChat?.users
                            );
                            navigate(`/ambassadoruserprofile?id=${other?._id}`);
                          }}
                          className="fs-6"
                          style={{
                            cursor: "pointer",
                            width: "45px",
                            height: "45px",
                            borderRadius: "50%",
                          }}
                        />
                        <div>
                          <div className="fs-5 fw-bold">
                            {getSender(user, selectedChat.users)}
                          </div>
                          <small
                            className="text-muted d-flex align-items-center "
                            style={{ fontSize: "12px", gap: "2px" }}
                          >
                            <img
                              src={require("../../pages/image/locchat.png")}
                              alt="loc"
                              style={{
                                width: "15px",
                                height: "14px",
                              }}
                              className=""
                            />
                            {capitalizeWords(partner?.city)},{" "}
                            {countryNameToCode[partner?.country]}
                          </small>
                        </div>
                      </div>
                      {/* <ProfileModal
                    user={getSenderFull(user, selectedChat.users)}
                  /> */}

                      <div className="" style={{ cursor: "pointer" }}>
                        <Dropdown>
                          <Dropdown.Toggle as="div">
                            <img
                              src={require(".././image/dot3.png")}
                              alt="dot"
                              className="  mx-sm-2 mx-2"
                              style={{ display: "inline-block", width: "25px" }}
                            />
                          </Dropdown.Toggle>
                          <div className="dropchat">
                            <Dropdown.Menu className="py-2 px-1  ">
                              <Dropdown.Item
                                className="fs-6 mt-1 fw600 text-dark d-none"
                                style={{ lineHeight: "21.79px" }}
                                onClick={() =>
                                  navigate("/ambassadoruserprofile")
                                }
                              >
                                {/* View Profile */}
                                {lg?.vprofile}
                              </Dropdown.Item>

                              {selectedChat?.status === "blocked" &&
                              selectedChat?.blockedBy === user._id ? (
                                <Dropdown.Item
                                  className="fs-6 mt-1 fw600 text-dark d-none"
                                  style={{ lineHeight: "21.79px" }}
                                  onClick={() => handleBlockUnblockChat()}
                                >
                                  {/* Unblock */}
                                  {lg?.unblock}
                                </Dropdown.Item>
                              ) : (
                                <Dropdown.Item
                                  className="fs-6 mt-1 fw600 text-dark d-none"
                                  style={{ lineHeight: "21.79px" }}
                                  onClick={() => handleBlockUnblockChat()}
                                >
                                  {/* Block */}
                                  {lg?.block}
                                </Dropdown.Item>
                              )}
                              <Dropdown.Item
                                className="fs-6 mt-1 fw600 text-[#ff0018]"
                                style={{ lineHeight: "21.79px" }}
                                onClick={() => handleShow()}
                              >
                                {/* // Report */}
                                {lg?.cancel}
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </div>
                        </Dropdown>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    {selectedChat.chatName.toUpperCase()}
                    {selectedChat?.groupAdmin === user?._id && (
                      <UpdateGroupChatModal
                        fetchMessages={fetchMessages}
                        fetchAgain={fetchAgain}
                        setFetchAgain={setFetchAgain}
                      />
                    )}
                  </>
                ))}
            </Text>
            <div
              className=" w-100  "
              style={{
                maxWidth: "100% ",
                // height: "1px",
                // border: "1px solid black",
                borderTop: "0.6px solid #000000", // halki aur patli line
                marginTop: "-3px",
              }}
            ></div>
            <Box
              display="flex"
              flexDir="column"
              justifyContent="flex-end"
              p={3}
              // bg="#D9D9D952"
              w="100%"
              h="100%"
              px="30px"
              borderRadius="lg"
              overflowY="hidden"
            >
              {loading ? (
                <Spinner
                  size="xl"
                  w={20}
                  h={20}
                  alignSelf="center"
                  margin="auto"
                />
              ) : selectedChat?.status === "accepted" ||
                currentBook?.name !== "Book Duo" ? (
                <div className="messages">
                  <ScrollableChat messages={messages} isGroupChat={selectedChat} />
                </div>
              ) : currentBook?.name === "Book Duo" ? ( // ✅ Only show for Book Duo
                <div
                  className="w-100 mt-5 mx-auto p-5"
                  style={{
                    maxWidth: "855px",
                    minHeight: user?.isAmbassador
                      ? selectedChat?.status === "rejected"
                        ? "222px"
                        : "322px"
                      : "222px",
                    backgroundColor: "#D9D9D98F",
                  }}
                >
                  {String(user?._id) === String(selectedChat?.event?.userId) ? (
                    // ✅ Organizer section
                    selectedChat?.status === "rejected" ? (
                      <div className="d-flex flex-column align-items-center">
                            <div className="pt-5 px-5 fs-5 fw-bold w-100 text-center">
                              
                          You have rejected the chat request from{" "}
                          {getSender(user, selectedChat.users)} about Book Duo{" "}
                          <span className="text-primary">
                            {currentBook?.title || "the Book Duo"}
                          </span>
                        </div>

                        <button
                          className="w-100 chat2wid border-0 text-white fw600 fs-5 rounded-1 mt-4"
                          style={{
                            backgroundColor: "#62C0C7",
                            maxWidth: "200px",
                            height: "44px",
                            margin: "0 auto",
                          }}
                          onClick={() => handleResponse(true)}
                        >
                          Reopen Request
                        </button>
                      </div>
                    ) : (
                            // ✅ Only organizer sees ActionCard (accept/reject)
                            
                      <ActionCard
                        users={selectedChat.users}
                        user={user}
                        handleReject={() => handleResponse(false)}
                        onClick={() => handleResponse(true)}
                        bookTitle={currentBook?.title}
                        duoType="Book Duo"
                        when=""
                        cover={resolveBookImageUrl(currentBook?.image)}
                        requester={{
                          name: getSender(user, selectedChat.users),
                        }}
                      />
                    )
                  ) : (
                    // ✅ Joiner (attendee) section
                    <div className="pt-5 px-sm-5 fs-5 fw-bold w-100 text-center">
                      Hi {user?.name},
                      {selectedChat?.status === "rejected" ? (
                        <>
                          The organizer has rejected your request to chat about{" "}
                          <span className="text-primary">
                            {currentBook?.title || "the Book Duo"}
                          </span>
                        </>
                      ) : selectedChat?.status === "accepted" ? (
                        <>
                          Your request to join{" "}
                          <span className="text-primary">
                            {currentBook?.title || "the Book Duo"}
                          </span>{" "}
                          has been accepted! You can now chat with the
                          organizer.
                        </>
                      ) : (
                        <>
                          <p>Waiting for the event creator’s response...</p>
                        </>
                      )}
                    </div>
                  )}
                </div>
              ) : null}
              {/* ✅ Don’t render anything if not Book Duo */}
              <FormControl
                onKeyDown={sendMessage}
                id="first-name"
                isRequired
                mt={3}
              >
                {istyping ? (
                  <div>
                    <Lottie
                      options={defaultOptions}
                      // height={50}
                      width={70}
                      style={{ marginBottom: 15, marginLeft: 0 }}
                    />
                  </div>
                ) : (
                  <></>
                )}
                <>
                  <div className="d-flex bg-white msgboxborder">
                    <div className="relat d-flex align-items-center">
                      <img
                        src={require(".././image/chatemj.png")}
                        width="24"
                        height="24"
                        className="mx-2"
                        style={{
                          width: "24px",
                          height: "24px",
                          cursor: "pointer",
                        }}
                        onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                      />

                      {/* Emoji Picker Dropdown */}
                      {showEmojiPicker && (
                        <div
                          className="position-absolute"
                          style={{ bottom: "40px", left: "0", zIndex: 100 }}
                        >
                          <EmojiPicker onEmojiClick={onEmojiClick} />
                        </div>
                      )}
                      <Input
                        variant="filled"
                        className="inputfous"
                        bg="white"
                        // placeholder="Enter a message.."
                        value={newMessage}
                        disabled={
                          iMage !== null ||
                          (currentBook?.name === "Book Duo" &&
                            selectedChat?.status !== "accepted")
                        }
                        onChange={typingHandler}
                      />
                      <div className="upload">
                        <div className="upr">
                          <IoIosAttach size={"25px"} />
                          <input
                            type="file"
                            accept="image/*"
                            name="myfile"
                            onChange={(e) => {
                              setNewMessage(e.target?.files[0]?.name);
                              console.log(e.target?.files[0]);
                              setIMage(e.target?.files[0]);
                            }}
                            disabled={
                              currentBook?.name === "Book Duo" &&
                              selectedChat?.status !== "accepted"
                                ? true
                                : false
                            }
                          />
                        </div>
                      </div>
                      <div
                        className="sendButton"
                        // onClick={(e) => sendMessage(e)}
                      >
                        <img
                          src={require(".././image/sendmsgicon.png")}
                          className="px-2  w-full h-full object-contain"
                          // onClick={sendMessage}
                          onClick={(e) => sendMessage(e)} // properly pass event
                        />
                      </div>
                    </div>
                  </div>
                </>
              </FormControl>
            </Box>
          </div>
        </>
      ) : (
        // to get socket.io on same page
        <Box d="flex" alignItems="center" justifyContent="center" h="100%">
          <Text fontSize="3xl" pb={3}>
            {/* Click on a user to start chatting */}
          </Text>
        </Box>
      )}
      {selectedChat ? (
        <section className="flex max-h-[81vh] min-h-[81vh] flex-col overflow-hidden rounded-2xl border border-[#eee] bg-white shadow-sm">
          {/* Header */}
          {messages &&
            (!selectedChat.isGroupChat ? (
              <>
                <div className="flex items-center justify-between gap-3 border-b border-[#f2f2f2] px-4 py-3">
                  <div className="flex items-center gap-3">
                    <button className="md:hidden rounded-xl p-2 text-slate-600 hover:bg-slate-50">
                      <ArrowLeft
                        size={18}
                        onClick={() => {
                          setSelectedChat("");
                          navigate("/chatChak/");
                          localStorage.removeItem("selectedUser");
                        }}
                      />
                    </button>
                    <img
                      src={
                        partner?.profileImage? partner?.profileImage.startsWith("http")? partner?.profileImage
                          :`${BASE_URL}/uploads/${partner.profileImage}`
                          : require("../../pages/image/addphotoicon.png")
                      }
                      alt={`${partner?.name || "User"} photo`}
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent parent click event
                        let other = getSenderFull(user, selectedChat?.users);
                        navigate(`/ambassadoruserprofile?id=${other?._id}`);
                      }}
                      className="grid h-9 w-9 place-items-center rounded-full font-semibold"
                      style={{ background: PRIMARY + "20", color: PRIMARY }}
                    />
                    <div>
                      <div className="text-[15px] font-semibold text-slate-900">
                        {getSender(user, selectedChat.users)}
                      </div>
                      <div className="text-xs text-slate-500">
                        {capitalizeWords(partner?.city)},{" "}
                        {countryNameToCode[partner?.country]}
                        <span className="inline-flex items-center gap-1">
                          <Circle size={8} className="text-emerald-500" />{" "}
                          online
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center gap-1">
                    <button className="rounded-xl p-2 text-slate-600 hover:bg-slate-50">
                      <div className="" style={{ cursor: "pointer" }}>
                        <Dropdown>
                          <Dropdown.Toggle as="div">
                            <MoreVertical size={18} />
                          </Dropdown.Toggle>
                          <div className="dropchat">
                            <Dropdown.Menu className="py-2 px-1  ">
                              <Dropdown.Item
                                className="fs-6 mt-1 fw600 text-dark d-none"
                                style={{ lineHeight: "21.79px" }}
                                onClick={() =>
                                  navigate("/ambassadoruserprofile")
                                }
                              >
                                {/* View Profile */}
                                {lg?.vprofile}
                              </Dropdown.Item>

                              {selectedChat?.status === "blocked" &&
                              selectedChat?.blockedBy === user._id ? (
                                <Dropdown.Item
                                  className="fs-6 mt-1 fw600 text-dark d-none"
                                  style={{ lineHeight: "21.79px" }}
                                  onClick={() => handleBlockUnblockChat()}
                                >
                                  {/* Unblock */}
                                  {lg?.unblock}
                                </Dropdown.Item>
                              ) : (
                                <Dropdown.Item
                                  className="fs-6 mt-1 fw600 text-dark d-none"
                                  style={{ lineHeight: "21.79px" }}
                                  onClick={() => handleBlockUnblockChat()}
                                >
                                  {/* Block */}
                                  {lg?.block}
                                </Dropdown.Item>
                              )}
                              <Dropdown.Item
                                className="fs-6 mt-1 fw600 text-[#ff0018]"
                                style={{ lineHeight: "21.79px" }}
                                onClick={() => handleShow()}
                              >
                                {/* // Report */}
                                {lg?.cancel}
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </div>
                        </Dropdown>
                      </div>
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <div className="flex items-center justify-between gap-3 border-b border-[#f2f2f2] px-4 py-3">
                <div className="flex items-center ">
                  <button className="md:hidden rounded-xl p-2 text-slate-600 hover:bg-slate-50 mr-[5px]">
                    <ArrowLeft
                      size={18}
                      onClick={() => {
                        setSelectedChat("");
                        navigate("/chatChak/");
                        localStorage.removeItem("selectedUser");
                      }}
                    />
                  </button>
                  <div className="text-[15px] font-semibold text-slate-900">
                    {selectedChat.chatName.toUpperCase()}
                  </div>
                </div>
                {selectedChat?.groupAdmin === user?._id && (
                  <UpdateGroupChatModal
                    fetchMessages={fetchMessages}
                    fetchAgain={fetchAgain}
                    setFetchAgain={setFetchAgain}
                  />
                )}
              </div>
            ))}
          {/* Messages */}
          <div className="flex-1 space-y-3 overflow-auto bg-[conic-gradient(at_top_left,_#f7fbfb,_#ffffff)] px-4 py-4">
            {loading ? (
              <Spinner
                size="xl"
                w={20}
                h={20}
                alignSelf="center"
                margin="auto"
              />
            ) : selectedChat?.status === "accepted" ||
              currentBook?.name !== "Book Duo" ? (
              <div className="messages">
                <ScrollableChat messages={messages} isGroup={selectedChat} />
              </div>
            ) : currentBook?.name === "Book Duo" ? ( // ✅ Only show for Book Duo
              <div
                className="w-100 mt-5 mx-auto p-1"
                style={{
                  maxWidth: "855px",
                  minHeight: "322px",
                  display: "flex",
                  marginBottom: "auto !important",
                  flexDirection: "column",
                  justifyContent: "flex-end",
                }}
              >
                 {String(user?._id) === String(selectedChat?.event?.userId) ? (
                    // ✅ Organizer section
                    selectedChat?.status === "rejected" ? (
                      <div className="d-flex flex-column align-items-center">
                            <div className="pt-5 px-5 fs-5 fw-bold w-100 text-center">
                              
                          You have rejected the chat request from{" "}
                          {getSender(user, selectedChat.users)} about Book Duo{" "}
                          <span className="text-primary">
                            {currentBook?.title || "the Book Duo"}
                          </span>
                        </div>

                        <button
                          className="w-100 chat2wid border-0 text-white fw600 fs-5 rounded-1 mt-4"
                          style={{
                            backgroundColor: "#62C0C7",
                            maxWidth: "200px",
                            height: "44px",
                            margin: "0 auto",
                          }}
                          onClick={() => handleResponse(true)}
                        >
                          Reopen Request
                        </button>
                      </div>
                    ) : (
                            // ✅ Only organizer sees ActionCard (accept/reject)
                            
                      <ActionCard
                        users={selectedChat.users}
                        user={user}
                        handleReject={() => handleResponse(false)}
                        onClick={() => handleResponse(true)}
                        bookTitle={currentBook?.title}
                        duoType="Book Duo"
                        when=""
                         cover={resolveBookImageUrl(currentBook?.image)}
                        requester={{
                          name: getSender(user, selectedChat.users),
                        }}
                      />
                    )
                  ) : (
                    // ✅ Joiner (attendee) section
                    <div className="pt-5 px-sm-5 fs-5 fw-bold w-100 text-center">
                      Hi {user?.name},
                      {selectedChat?.status === "rejected" ? (
                        <>
                          The organizer has rejected your request to chat about{" "}
                          <span className="text-primary">
                            {currentBook?.title || "the Book Duo"}
                          </span>
                        </>
                      ) : selectedChat?.status === "accepted" ? (
                        <>
                          Your request to join{" "}
                          <span className="text-primary">
                            {currentBook?.title || "the Book Duo"}
                          </span>{" "}
                          has been accepted! You can now chat with the
                          organizer.
                        </>
                      ) : (
                        <>
                          <p>Waiting for the event creator’s response...</p>
                        </>
                      )}
                    </div>
                  )}
              </div>
            ) : null}
            <div ref={endRef} />
          </div>

          {/* Composer */}
          <div className="flex items-end gap-2 border-t border-[#f2f2f2] p-3">
            <button className="relative rounded-xl p-2 text-slate-600 hover:bg-slate-50">
              {showEmojiPicker ? (
                <X
                  size={18}
                  onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                />
              ) : (
                <Smile
                  size={18}
                  onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                />
              )}

              {showEmojiPicker && (
                <div
                  className="position-absolute"
                  style={{ bottom: "40px", left: "0", zIndex: 100 }}
                >
                  <EmojiPicker onEmojiClick={onEmojiClick} />
                </div>
              )}
            </button>

            <button className="w-[34px] h-[34px] relative rounded-xl p-2 text-slate-600 hover:bg-slate-50">
              <div className="upload">
                <div className="upr">
                  <Paperclip size={18} />
                  <input
                    type="file"
                    accept="image/*"
                    name="myfile"
                    onChange={(e) => {
                      setNewMessage(e.target.files[0].name);
                      console.log(e.target.files[0]);
                      setIMage(e.target.files[0]);
                    }}
                    disabled={
                      currentBook?.name === "Book Duo" &&
                      selectedChat?.status !== "accepted"
                        ? true
                        : false
                    }
                  />
                </div>
              </div>
            </button>
            <div className="flex-1 rounded-xl ring-1 ring-[#e9e9e9] bg-[#fbfbfb]">
              <textarea
                rows={1}
                value={newMessage}
                disabled={
                  iMage !== null ||
                  (currentBook?.name === "Book Duo" &&
                    selectedChat?.status !== "accepted")
                }
                onChange={typingHandler}
                placeholder="Write a message"
                className="w-full resize-none rounded-xl bg-transparent px-3 py-2 text-sm outline-none"
              />
            </div>
            <button
              className="inline-flex items-center gap-2 rounded-xl bg-[var(--primary)] px-4 py-2 text-sm font-medium text-white hover:brightness-95"
              style={{ ["--primary"]: PRIMARY }}
              onClick={(e) => sendMessage(e)}
            >
              <Send size={16} />{" "}
              <span className="hidden md:inline-block">
                {lg?.send || "Send"}
              </span>
            </button>
          </div>
        </section>
      ) : (
        // to get socket.io on same page
        <Box d="flex" alignItems="center" justifyContent="center" h="100%">
          <Text fontSize="3xl" pb={3}>
            {/* Click on a user to start chatting */}
          </Text>
        </Box>
      )}
      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="custom-gropmodel heigh"
        backdrop={true}
      >
        <Modal.Header className=" border-0">
          <img
            className=" border-0 closebtnevtn "
            src={require("../../components/image/close.png")}
            alt="logo"
            onClick={handleClose}
          />
        </Modal.Header>
        <Modal.Title className="mx-5 ">
          <div
            className=" fw-bold  mt-3 mt-sm-0 mx-md-4 text-center px-md-2 aboutauther  "
            style={{ fontSize: "27px" }}
          >
            {/* Complete your registration */}
            Are you sure you want to cancel?
          </div>
        </Modal.Title>
        <Modal.Body className="mx-auto mt-3">
          <div className=" text-center ">
            <button
              className="w-100 modelbtnjoin text-white ftzcopy text-center border-0 rounded-1 fw600 "
              style={{
                maxWidth: "162px ",
                fontSize: "22px",
                height: "45px",
                padding: "0px 20px",
                backgroundColor: "#34C3C9",
              }}
              onClick={handleCancel}
            >
              Cancel
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SingleChat;
